import { CheckoutSessionStatus } from '@nemuru-eng/js-api-client';

import { FunnelStageStep } from '@/types/funnelStageStep';

export const ALLOWED_CHECKOUT_SESSION_STATUSES_FOR_MULTI_SELECT_FILTER = [
  CheckoutSessionStatus.INITIAL,
  CheckoutSessionStatus.CHALLENGE,
  CheckoutSessionStatus.CONFIRMED,
  CheckoutSessionStatus.DENIED,
  CheckoutSessionStatus.DESISTED,
  CheckoutSessionStatus.CANCELLED,
  CheckoutSessionStatus.EXPIRED,
];

export const INITIAL_CHECKOUT_SESSION_STATUSES_FOR_MULTI_SELECT_FILTER = [
  CheckoutSessionStatus.INITIAL,
  CheckoutSessionStatus.CHALLENGE,
  CheckoutSessionStatus.CONFIRMED,
  CheckoutSessionStatus.DENIED,
  CheckoutSessionStatus.DESISTED,
  CheckoutSessionStatus.CANCELLED,
];

// Stands agents only work on active applications, so their list never offers the final statuses
export const STANDS_AGENT_CHECKOUT_SESSION_STATUSES_FOR_MULTI_SELECT_FILTER = [
  CheckoutSessionStatus.INITIAL,
  CheckoutSessionStatus.CHALLENGE,
];

export const CHECKOUT_SESSION_STATUS_DEFINITIONS = {
  [CheckoutSessionStatus.INITIAL]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_APPLICATION_STARTED',
    colorPaletteName: 'default',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.STARTED,
  },
  [CheckoutSessionStatus.CHALLENGE]: {
    DESCRIPTION_T_ID: 'PENDING',
    colorPaletteName: 'warning',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CHALLENGE,
  },
  [CheckoutSessionStatus.CONFIRMED]: {
    DESCRIPTION_T_ID: 'CAPTURE_PENDING',
    colorPaletteName: 'success',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CONFIRMED,
  },
  [CheckoutSessionStatus.DESISTED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DESISTED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DESISTED,
  },
  [CheckoutSessionStatus.EXPIRED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_ORDER_EXPIRED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.EXPIRED,
  },
  [CheckoutSessionStatus.CANCELLED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_CANCELLED',
    colorPaletteName: 'minor',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.CANCELLED,
  },
  [CheckoutSessionStatus.DENIED]: {
    DESCRIPTION_T_ID: 'STATUS_DESC_DENIED',
    colorPaletteName: 'error',
    colorType: 'main',
    SECTION_T_ID: FunnelStageStep.DENIED,
  },
};
